<div class="settings-dc__title">
    <div class="settings-dc__title--reg">Registration parameter</div>
    <div>Value</div>
</div>
<div class="settings-dc--container">
    <div class="settings-dc--items" *ngFor="let setting of settings; let i = index" [attr.data-index]="i">
        <div>
            <ui-input>
                <input uiInput
                    type="text"
                    name="settings_{{i}}_name"
                    [(ngModel)]="settings[i].name"
                    (ngModelChange)="sendOutputSettingsDc(i)"
                    required
                    [ngClass]="{'settings-dc--input-error': settings[i].errorValue}"/>
            </ui-input>
        </div>
        <div class="settings-dc--colon">:</div>
        <div>
            <ui-input>
                <input uiInput
                    type="text"
                    name="settings_{{i}}_value"
                    [(ngModel)]="settings[i].value"
                    (ngModelChange)="sendOutputSettingsDc()"/>
            </ui-input>
        </div>
        <div class="settings-dc--remove">
            <button type="button"
                (click)="delete(i)"
                [class.disabled]="!canDelete()"
                [uiTooltip]="deleteTooltip(i)">
                <svg-icon class="delete" src="/assets/icons/delete.svg"></svg-icon>
            </button>
        </div>
    </div>
    <div class="settings-dc--plus">
        <a class="colored icon" (click)="addItem()">
            <svg-icon src="/assets/icons/plus.svg"></svg-icon>
            <span>Add fields</span>
        </a>
    </div>
</div>
